import { createRouter, createWebHistory } from 'vue-router';
import WorkoutView from '../views/WorkoutView';
import DesktopView from '../views/DesktopView';
import AccountView from '../views/AccountView';
import AboutView from '../views/AboutView';
import ExerciseView from '@/views/ExerciseView';
import AddEditWorkout from '@/components/AddEditWorkout';
import WorkoutDetail from '@/components/Workout';
import ImportWorkout from '@/components/ImportWorkout.vue';
import EmomWorkout from '@/views/EmomWorkout.vue';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

import Login from '@/views/Login.vue';
import { dbConnection } from '@/firestore/firestore';
const routes = [
  {
    path: '/',
    name: 'home',
    component: WorkoutView,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/workoutView',
    name: 'workoutView',
    component: WorkoutView,
    props: true,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/emom',
    name: 'emom',
    component: EmomWorkout,
    props: true,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/exerciseView',
    name: 'exerciseView',
    component: ExerciseView,
    props: true,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/desktopView',
    name: 'desktopView',
    component: DesktopView,
    props: true,
  },
  {
    path: '/accountView',
    name: 'accountView',
    component: AccountView,
    props: true,
  },
  {
    path: '/aboutView',
    name: 'aboutView',
    component: AboutView,
    props: true,
  },
  {
    path: '/addWorkout',
    name: 'addWorkout',
    component: AddEditWorkout,
    props: true,
  },
  {
    path: '/doWorkout',
    name: 'doWorkout',
    component: WorkoutDetail,
    props: true,
  },
  {
    path: '/importWorkout',
    name: 'importWorkout',
    component: ImportWorkout,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const getAuthentication = async () => {
  return new Promise((resolve) => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        localStorage.uid = user.uid;
        console.log(user.uid);
        resolve(user.uid);
      } else {
        dbConnection.getLoginToken().then((result) => {
          if (result) {
            localStorage.uid = result.user.uid;
            resolve(result.user.uid);
          } else {
            resolve(null);
          }
        });
      }
    });
  });
};
router.beforeEach(async (to, from, next) => {
  console.log(from.name + ' ' + to.name);
  if (to.name !== 'aboutView' && to.name !== 'emom') {
    const uid = await getAuthentication();
    if (uid) {
      next(to.name === 'login' ? { name: 'home' } : undefined);
    } else if (to.name === 'login') {
      next();
    } else {
      next({ name: 'login' });
    }
  } else {
    next();
  }
});

export default router;
